const BASE = `${window.location.origin}/api/alojamentos`

export async function alojamentoApi(path = "", method = "GET", body) {
  const response = await fetch(`${BASE}${path}`, {
    method,
    ...(body !== undefined ? { headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) } : {})
  })
  const result = await response.json().catch(() => ({}))
  if (!response.ok || !result.sucesso) throw new Error(result.erro || "Não foi possível concluir a operação")
  return result.dados
}

export async function baixarRelatorioAlojamentos({ formato, id, filtros = {} }) {
  const parametros = new URLSearchParams({ ...filtros, formato })
  const caminho = id == null ? "/exportar" : `/${id}/exportar`
  const response = await fetch(`${BASE}${caminho}?${parametros}`)
  if (!response.ok) {
    const result = await response.json().catch(() => ({}))
    throw new Error(result.erro || "NÃ£o foi possÃ­vel gerar o relatÃ³rio de alojamentos")
  }
  const blob = await response.blob(), url = URL.createObjectURL(blob), link = document.createElement("a")
  link.href = url
  link.download = response.headers.get("Content-Disposition")?.match(/filename="([^"]+)"/)?.[1] || `controle_alojamentos.${formato}`
  document.body.appendChild(link); link.click(); link.remove(); URL.revokeObjectURL(url)
}

export const hojeISO = () => {
  const p = Object.fromEntries(new Intl.DateTimeFormat("en-US", { timeZone: "America/Sao_Paulo", year: "numeric", month: "2-digit", day: "2-digit" }).formatToParts(new Date()).map(x => [x.type, x.value]))
  return `${p.year}-${p.month}-${p.day}`
}
export const dataBR = valor => valor ? String(valor).slice(0, 10).split("-").reverse().join("/") : "—"
export const cepBR = valor => valor ? String(valor).replace(/^(\d{5})(\d{3})$/, "$1-$2") : "—"
